import { useTranslation } from 'react-i18next';
import { useCallback } from 'react';
import { useLocale } from '@pflegenavi/frontend/localization';

export const useMapResolutionDate = (): ((
  date: Date | undefined | 'unknown'
) => string) => {
  const { t } = useTranslation();
  const locale = useLocale();

  return useCallback(
    (date) => {
      if (date === 'unknown') {
        return t('receipts.batch.resolution-date-unknown');
      }
      return date ? new Date(date).toLocaleDateString(locale) : '';
    },
    [t, locale]
  );
};
